import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ProtectedRoute: React.FC = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="flex justify-center items-center h-screen"><i className="fas fa-spinner fa-spin text-4xl"></i></div>;
    }

    // A user must exist and must NOT be anonymous to access protected routes.
    return user && !user.isAnonymous ? <Outlet /> : <Navigate to="/checkout/auth" replace />;
};

export default ProtectedRoute;